<template>
  <div v-if="hasPermission(permissions.withdrawTypesCreate)">
    <content-header>{{ $t('createWithdrawType') }}</content-header>
    <v-content>
      <b-card>
        <b-card-body>
          <form class="forms-sample" @submit.prevent="onSubmit">
            <text-input id="name" :name="$t('name')" :validate="$v" :required="true" :max-length="true" :is-loading="isLoading" />
            <submit-input :name="$t('create')" :disabled="isLoading"/>
            <is-loading v-if="isLoading" />
          </form>
        </b-card-body>
      </b-card>
    </v-content>
  </div>
</template>

<script>
import Content from "@/components/Content";
import ContentHeader from "@/components/ContentHeader";
import { required, maxLength } from 'vuelidate/lib/validators'
import IsLoading from "@/components/IsLoading";
import {WithdrawType} from "@/models/WithdrawType";
import SubmitInput from "@/components/Inputs/SubmitInput";
import TextInput from "@/components/Inputs/TextInput";
import {permissions} from "@/plugins/constants";

export default {
  name: "WithdrawTypeCreate",
  components: {TextInput, SubmitInput, ContentHeader, 'v-content': Content, IsLoading},
  data() {
    return {
      form: this.$helpers.convertArrayToObject(new WithdrawType().fillAbles),
      isLoading: false,
      selectedItem: {},
      permissions: permissions
    }
  },
  validations: {
    form: {
      name: {required, maxLength: maxLength(255)},
    }
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$pending || this.$v.$error) return false;
      this.isLoading = true;
      this.$store.dispatch('withdrawTypes/CREATE', this.form).then(() => {
        this.$v.$reset();
        this.$router.push({name: "withdrawTypes"})
      }).catch(() => this.isLoading = false);
    },
  }
}
</script>
